import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { OnboardingManager } from '@/components/onboarding/OnboardingManager';
import { useUser } from '@/contexts/UserContext';

const OnboardingPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const accountType = searchParams.get('type') as 'talent' | 'agent' | 'brand' | 'venture';
  const isCompletion = searchParams.get('mode') === 'completion';
  // Note: We no longer block access based on beta access here
  // Users should complete their full profile setup first, then see the pending approval page

  const handleBack = () => {
    if (isCompletion) {
      navigate('/profile');
    } else {
      navigate('/role-selection');
    }
  };

  if (!accountType || !['talent', 'agent', 'brand', 'venture'].includes(accountType)) {
    navigate('/role-selection');
    return null;
  }

  return (
    <OnboardingManager
      accountType={accountType}
      onBack={handleBack}
      isCompletion={isCompletion}
    />
  );
};

export default OnboardingPage;